import SpeciesManage from "./SpeciesManage";
import SpeciesManageSpeciesTrait from "./SpeciesManageSpeciesTrait";

export default SpeciesManage;
export { SpeciesManage, SpeciesManageSpeciesTrait };
